import { computed, inject, ref } from 'vue';

interface FormItemProps {
  required?: boolean;
  desc?: string;
  rule?: string;
}

interface ToFormItemContext {
  required?: boolean;
  label?: string;
}

interface ToFormContext {
  comparable?: boolean;
}

export function useFormItem(props: FormItemProps) {
  const ToFormItem = inject<ToFormItemContext>('ToFormItem', {});
  const ToForm = inject<ToFormContext>('ToForm', {});

  const errorTip = ref('');
  const errorType = ref('rule');

  // 是否可验证
  const verifiable = computed(() => true);

  // 验证是否必填
  const validateRequired = computed(() => {
    if (props.required) {
      return 'true';
    } else if (ToFormItem.required) {
      return 'true';
    } else {
      return 'false';
    }
  });

  // 验证描述
  const validateDesc = computed(() => {
    if (props.desc) {
      return props.desc;
    } else if (ToFormItem.label) {
      return ToFormItem.label;
    } else {
      return '';
    }
  });

  return {
    verifiable,
    validateRequired,
    validateDesc,
    errorTip,
    errorType,
    ToForm,
    ToFormItem,
  };
}
